<template>
  <div class="h-100">
    <!-- Arrows sidebar -->
    <a
      href="#"
      :class="[
        'btn-toolbars-collapse bg-secondary text-white',
        { 'toolbars-shown': isToolbarsCollapsed },
      ]"
      @click.prevent="updateToolbarsStatus"
      v-if="canCollapseLeftBar && user.video_wall !== 1"
    >
      <feather-icon
        size="20"
        icon="ChevronLeftIcon"
        v-b-tooltip.hover.rigth.viewport="$t('tooltips.show_left_sidebar')"
      />
    </a>
    <a
      href="#"
      :class="[
        'btn-toolbars-collapse-right bg-secondary text-white',
        { 'toolbars-shown': isToolbarsCollapsedRight },
      ]"
      @click.prevent="updateToolbarsStatusRight"
    >
      <feather-icon
        v-if="canCollapseRightBar && user.video_wall !== 1"
        size="20"
        icon="ChevronRightIcon"
        v-b-tooltip.hover.left.viewport="$t('tooltips.show_right_sidebar', 1)"
      />
    </a>
    <div
      class="dashboard-container"
      :class="[
        {
          'hidden-toolbars': isToolbarsCollapsed,
          'hidden-toolbars-right': isToolbarsCollapsedRight,
        },
      ]"
    >
      <side-bar
        id="side-bar"
        :style="`width: ${sidebarWidth}px;`"
        class="d-flex flex-column"
      />

      <div class="container-center">
        <div
          id="dashboard"
          @dragover="onDragOver"
          @drop="onDrop"
          class="position-relative h-100"
          :class="[{ 'selection-dnd': slotDataWillOpenATab }]"
        >
          <!-- Tabs -->
          <tabs-component />
        </div>
        <!-- <bottom-bar v-if="user.video_wall === 0" id="bottom-bar" /> -->
      </div>
      <side-bar-right
        v-if="user.video_wall === 0"
        id="side-bar-right"
        @dragover.stop="onDragOver"
        @drop.stop="onDrop"
        :style="`width: ${sidebarRightWidth}px;`"
      />
    </div>
    <floating-cam-v2-widget
      v-for="video in floatVideos"
      :key="video.uuid"
      :camera-id="video.id"
      :uuid="video.uuid"
      :camera-type="video.type"
      :camera-proxy-id="video.camera_proxy_id"
      @destroy="handleDestroy(video)"
    />
    <layout-modal />
    <alarm-action-modal />
    <assign-task-modal
      modal-id="grid-alarm-reopen-modal"
      :alarm="alarmForReopenModal"
      :reopen-mode="true"
      @task-assigned="onReopenTaskAssigned"
      @hidden="onReopenModalHidden"
    />
    <scripts-modal />
    <subsystem-action-modal />
    <keyboard-events />
    <image-modal />
    <alarm-action-send-seproban-modal />
    <user-shift-modal
      :show-user-shift-modal="showUserShiftModal"
      @update:isActive="showUserShiftModal = false"
    />
  </div>
</template>

<script>
import store from "@/store";
import BottomBar from "./BottomBar.vue";
import SideBar from "./SideBar.vue";
import SideBarRight from "./SideBarRight.vue";
import TabsComponent from "./TabsComponent.vue";
import LayoutModal from "./widgets/LayoutModal.vue";
import AlarmActionModal from "./widgets/AlarmActionModal.vue";
import SubsystemActionModal from "./widgets/SubsystemActionModal";
import ScriptsModal from "./widgets/ScriptsModal";
import KeyboardEvents from "./KeyboardEvents.vue";
import interact from "interactjs";
import LayoutApi from "@/libs/LayoutApi";
import FloatingCamV2Widget from "./widgets/FloatingCamV2Widget.vue";
import ImageModal from "./widgets/ImageModal.vue";
import ConfigVideowall from "@/libs/ConfigVideowall";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import AlarmActionSendSeprobanModal from "./widgets/SeprobanModal/AlarmActionSendSeprobanModal.vue";
import AssignTaskModal from "@/views/alarm/AssignTaskModal.vue";
import UserShiftModal from "./components/UserShiftModal.vue";
import { debounce } from "lodash";
// import ChatBot from "./ChatBot.vue";
import ability from "@/libs/acl/ability";

const configVideowall = new ConfigVideowall(store);

export default {
  components: {
    SideBar,
    SideBarRight,
    BottomBar,
    TabsComponent,
    LayoutModal,
    AlarmActionModal,
    AssignTaskModal,
    SubsystemActionModal,
    KeyboardEvents,
    ScriptsModal,
    ImageModal,
    FloatingCamV2Widget,
    AlarmActionSendSeprobanModal,
    UserShiftModal
    // ChatBot
  },
  data() {
    return {
      isDraggable: true,
      isResizable: true,
      isComponentVisible: true,
      showUserShiftModal: false
    };
  },
  created() {
    if (this.shiftRegister) {
      this.showUserShiftModal = true;
    }

    this.debouncedUpdateUserConfig = debounce(() => {
      store.dispatch("grid/updateUserConfig");
    }, 300);
  },
  mounted() {
    document.body.classList.add("overflow-hidden");
    if (!this.isToolbarsCollapsed) {
      this.initResizable();
    }
    interact("#side-bar-right").resizable({
      edges: { left: true },
      listeners: {
        move: this.updateSidebarRightWidth,
      },
      modifiers: [
        interact.modifiers.restrictEdges({
          outer: "parent",
        }),
        interact.modifiers.restrictSize({
          min: { width: 265 },
          max: { width: 650 },
        }),
      ],
      inertia: {
        resistance: 8,
        minSpeed: 100,
        endSpeed: 50,
      },
      margin: 8,
    });

    store.dispatch("log_incident/getAll");
    store.dispatch("taken_alarms/getTakenAlarms");

    if (store.state.user.user.device_interphone) {
      store.dispatch("sip/subscribeToCalls", { user_id: store.state.user.user.id });
      setTimeout(() => {
        store.dispatch("sip/subscribeToCalls", { user_id: store.state.user.user.id });
      }, 10000);
    }

    if (this.user.video_wall == 1) {
      this.handleVideoWallConnections();
    }
    if (!this.canCollapseRightBar) {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED_RIGHT",
        false
      );
    }
  },
  beforeDestroy() {
    document.body.classList.remove("overflow-hidden");
    if (this.debouncedUpdateUserConfig) {
      this.debouncedUpdateUserConfig.cancel();
    }
    if (this.user.video_wall == 1) {
      window.Echo.leave(`video-wall-users`);
    }
  },
  computed: {
    canCollapseLeftBar() {
      return ability.can("show_btn_to_hide_left_sidebar", "Workspace");
    },
    canCollapseRightBar() {
      return ability.can("show_btn_to_hide_right_sidebar", "Workspace");
    },
    alarmForReopenModal() {
      const selected = this.$store.state.grid.selectedAlarm;
      return selected?.action === "reopen" ? selected.alarm : null;
    },
    tabs() {
      return store.state.grid.tabs;
    },
    tabsQty() {
      return this.tabs ? Object.keys(this.tabs).length : 0;
    },
    slotData() {
      return store.state.grid.slotData;
    },
    isToolbarsCollapsed() {
      return store.state.psimConfig.isToolbarsCollapsed;
    },
    isToolbarsCollapsedRight() {
      return store.state.psimConfig.isToolbarsCollapsedRight;
    },
    sidebarWidth() {
      if (this.user.video_wall === 1) {
        return 0;
      } else {
        return store.state.grid.sidebarWidth;
      }
    },
    sidebarRightWidth() {
      if (this.user.video_wall === 1) {
        return 0;
      } else {
        return store.state.grid.sidebarRightWidth;
      }
    },
    user() {
      return store.getters["user/getUser"];
    },
    floatVideos() {
      return store.getters["grid/getFloatVideos"];
    },
    slotDataWillOpenATab() {
      if (this.tabsQty > 0) {
        return false;
      }
      return store.getters["grid/slotDataWillOpenATab"];
    },
    shiftRegister() {
      return (localStorage.getItem('shift_register') === 'true');
    }
  },
  methods: {
    onReopenTaskAssigned(responseData) {
      const selected = this.$store.state.grid.selectedAlarm;
      const slotPos = selected?.slot?.pos;
      this.$store.dispatch("grid/unsetSelectedAlarm");
      if (slotPos && responseData) {
        const slotData =
          responseData.data != null ? { data: responseData.data } : responseData;
        new LayoutApi(store).updateSlotData(slotPos, SLOT_TYPES.INFO, slotData);
      }
    },
    onReopenModalHidden() {
      this.$store.dispatch("grid/unsetSelectedAlarm");
    },
    updateToolbarsStatus() {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED",
        !store.state.psimConfig.isToolbarsCollapsed
      );

      this.sidebarWidth;
    },
    updateToolbarsStatusRight() {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED_RIGHT",
        !store.state.psimConfig.isToolbarsCollapsedRight
      );
    },
    updateSidebarWidth(event) {
      store.commit("grid/updateSidebarWidth", event.rect.width);
      this.debouncedUpdateUserConfig();
    },
    updateSidebarRightWidth(event) {
      store.commit("grid/updateSidebarRightWidth", event.rect.width);
      this.debouncedUpdateUserConfig();
    },
    async handleVideoWallConnections() {
      await store.dispatch("layouts/getUserLayouts");
      await store.dispatch("video_wall/updateVideoWallUserStatus", {
        id_user: this.user.id,
        status: "online",
      });

      window.Echo.join("video-wall-users");

      // Video wall websocket
      window.Echo.private(`video-wall-users-${this.user.id}`).listen(
        ".videoWall",
        (data) => {
          try {
            const tab = data.message.tab;
            const slots = tab.data.slots;
            const idLayout = tab.data.layout;

            configVideowall.setTab(slots, idLayout);
          } catch (error) {
            console.log(`Websocket video-wall-users-${this.user.id}`, error);
          }
        }
      );
    },
    onDragOver(e) {
      e.preventDefault();
    },
    onDrop(e) {
      e.preventDefault();
      if (this.slotData && this.slotData.source === SOURCES.SUBSYSTEM_TREE_DND) {
        store.dispatch(this.slotData.type, {
          data: this.slotData.data,
          source: SOURCES.SUBSYSTEM_TREE,
        });
      }
    },
    initResizable() {
      interact("#side-bar").resizable({
        edges: { right: true },
        listeners: {
          move: this.updateSidebarWidth,
        },
        modifiers: [
          interact.modifiers.restrictEdges({
            outer: "parent",
          }),
          interact.modifiers.restrictSize({
            min: { width: 250 },
            max: { width: 600 },
          }),
        ],
        inertia: {
          resistance: 8,
          minSpeed: 100,
          endSpeed: 50,
        },
        margin: 8,
      });
    },
    handleDestroy(video) {
      this.$store.dispatch("grid/removeFloatVideos", video);
    },
  },
  watch: {
    "$store.state.grid.selectedAlarm": {
      handler(selected) {
        if (selected?.action === "reopen" && selected?.alarm) {
          this.$nextTick(() => {
            this.$bvModal.show("grid-alarm-reopen-modal");
          });
        }
      },
    },
    isToolbarsCollapsed(newValue) {
      if (newValue) {
        interact("#side-bar").unset();
      } else {
        this.initResizable();
      }
    },
    isDragEnter(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.isDragEnter = false;
        }, 2000);
      }
    },
  },
};
</script>
